import React, { useCallback, useMemo } from 'react';
import { useDispatch } from "react-redux";
import { WorldMapProvider } from "../../../contexts/WorldMapContext";
import { MAP_ELEMENT } from "../../../contexts/WorldMapContext/constants";
import DiseaseZonesBox from "../../../contexts/WorldMapContext/DiseaseZonesBox";
import GoogleMap from "../../../contexts/WorldMapContext/GoogleMap";
import { MarkerPopupProvider } from "../../../contexts/WorldMapContext/MarkerPopup";
import { selectViewMode } from '../../../util/store/selectors';
import { useSelector } from '../../../util/store/store';
import { VIEW_MODE } from '../../../util/varibles/permission';
import Control from "../Control";
import DiseasedZones from "../Control/RightControl/DiseasedZones";
import { dashboardActions } from "../reducer";
import styles from "../style.module.scss";
import WrapperTrackingOp from "../WrapperTrackingOp";
import Factories from "./Factories";
import Pois from "./Pois";
import ProductionAreas from "./ProductionAreas";
import Sites from "./Sites";
import Vessels from "./Vessels";

const GroupWithOperation = () => {
    const target = useSelector(state => state.dashboard.target);
    const ids: Set<string> = useMemo(() => {
        const { data, targetType } = target;
        if (targetType === MAP_ELEMENT.POLYLINE) {
            const { markers: markersOfSelected = [], id } = data || {};
            const result = new Set<string>(markersOfSelected.map((item: any) => item.id));
            return (result.size === 0 && id) ? new Set<string>(id) : result;
        }
        return new Set()
    }, [target]);
    return <>
        <Sites ids={ids} />
        <Factories ids={ids} />
        <Vessels ids={ids} />
        <Pois ids={ids} />
    </>
}

interface IProps {
}

const Map: React.FC<IProps> = () => {
    const dispatch = useDispatch()
    const viewMode = useSelector(selectViewMode);

    const showInfo = useCallback((props: any) => {
        dispatch(dashboardActions.showInfo(props))
    }, [dispatch])

    return <WorldMapProvider>
        <GoogleMap onClick={() => showInfo({})}>
            <MarkerPopupProvider>
                <GroupWithOperation />
            </MarkerPopupProvider>
            <ProductionAreas />
            {viewMode === VIEW_MODE.VESSEL && <DiseasedZones showControl={false} />}
            <DiseaseZonesBox onClick={data => showInfo({ data, targetType: MAP_ELEMENT.DISEASED_ZONE })} />
            <div className={styles.screen}>
                <Control />
                <WrapperTrackingOp />
            </div>
        </GoogleMap>
    </WorldMapProvider>;
};

export default Map;
